<template>
  <div>
    <!-- 出入金明细 -->
    <el-dialog :title="$t('message.entryAndExitDetails')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1800px">
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 确认入账时间 -->
          <li>{{ $t('message.confirmTheCreditingTime') }}</li>
          <!-- 提出时间 -->
          <li>{{ $t('message.forwardTime') }}</li>
          <!-- 客户名 -->
          <li>{{ $t('message.customerName') }}</li>
          <!-- 注文書・配送書 -->
          <li class="flex2">{{ $t('message.noteDocumentsdeliveryBooks') }}</li>
          <!-- 内容 -->
          <li class="flex3">{{ $t('message.content') }}</li>
          <!-- 名义 -->
          <li>{{ $t('message.mingYi') }}</li>
          <!-- 账单类型 -->
          <li>{{ $t('message.billingType') }}</li>
          <!-- 交易方式 -->
          <li>{{ $t('message.transactionWay') }}</li>
          <!-- 出入金金额 -->
          <li>出金額</li>
          <li>入金額</li>
          <!-- 残金 -->
          <li>{{ $t('message.residualGold') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ index + 1 }}</li>
          <!-- 确认入账时间 -->
          <li>
            <div style="width: 80px;text-align: center;">{{ item.confirm_at }}</div>
          </li>
          <!-- 提出时间 -->
          <li>
            <div style="width: 80px;text-align: center;">{{ item.created_at }}</div>
          </li>
          <!-- 客户名 -->
          <li>
            <div>
              <p> {{ item.user_id }}</p>
              {{ item.realname }}
              {{ item.user ? item.user.realname : '' }}
            </div>
          </li>
          <!-- 注文書・配送書 -->
          <li class="flex2">
            <div v-if="item.order_sn">
              <!-- 2023/2/22 大榭说配送单号和订单号都用这个参数 -->
              <p>
                <!-- 配送单详情链接 -->
                {{ item.order_sn.substr(0, 1) == 'P' ? '配送書' : '注文書' }} <router-link
                  v-if="item.order_sn.substr(0, 1) == 'P'" class="redFont"
                  :to="'/porderDetail?porder_sn=' + item.order_sn" target="_blank">
                  {{ item.order_sn }}
                </router-link>
                <!-- 订单详情链接 -->
                <router-link v-else class="redFont" :to="'/orderPaymentDetail?order_sn=' + item.order_sn"
                  target="_blank">
                  {{ item.order_sn }}
                </router-link>
              </p>
            </div>
          </li>
          <!-- 内容 -->
          <li class="flex3">
            <div v-if="item.adjust_detail != false && item.adjust_detail != null" class="showDetail">
              <div style=" overflow: hidden;">
                <p v-for="(item, index) in item.adjust_detail[0]" :key="index">
                  {{ item }}
                </p>
              </div>
            </div>
          </li>
          <!-- 名义 -->
          <li>{{ item.client_bill_reason }}</li>
          <!-- 账单类型 -->
          <li>{{ item.bill_type_name }}</li>
          <!-- 交易方式 -->
          <li>{{ item.bill_method_name }}</li>
          <!-- 2023/2/22 原型图上出入金分开显示,接口是一起显示,按接口来 -->
          <!-- 出入金金额 -->
          <li>{{ item.amount <= 0 ? item.amount - item.amount - item.amount : '' }}</li>
          <li>{{ item.amount >= 0 ? item.amount : '' }}</li>
          <!-- 残金 -->
          <li>{{ item.balance }}</li>
        </ul>
        <div v-if="tableData == false" class="No_data">暂无数据</div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="showConfirm">
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <el-button type="primary" @click="$emit('confirm')">{{ $t('message.ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    tableData: { type: Array },
    showConfirm: { type: Boolean, default: false }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;


    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  ul {
    li {
      word-break: break-all;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex3 {
    flex: 3;
    overflow: hidden;
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;


    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}
</style>
